// extracted by mini-css-extract-plugin
export var falconContainer = "_v1-2";
export var offerCenter = "_v1-0";
export var roktContainer = "_v1-1";